import Bugsnag from '@bugsnag/js';
import { useCallback, useEffect, useState } from 'react';
import { AppleAuthConnect } from 'swagger/models';
import { useAppleConnectMutation } from 'components/auth/hooks/authFlowHooks';

export default function useAuthProvidersInitializer() {
  const insertGoogleScript = useCallback(() => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js';
    script.onload = () => {};
    document.body.appendChild(script);
  }, []);

  const appleConnectMutation = useAppleConnectMutation();

  const [nonce, setNonce] = useState<AppleAuthConnect | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const value = await appleConnectMutation.mutateAsync();
        setNonce(value.data);
      } catch (e) {
        Bugsnag.notify(e);
        console.error(e);
      }
    })();
  }, []);

  const [appleInitialized, setAppleInitialized] = useState(false);

  const initializeAppleLogin = () => {
    if (!nonce) return;

    window.AppleID?.auth?.init({
      clientId: 'com.boatsetter.web', // This is the service ID we created.
      scope: 'name email', // To tell apple we want the user name and emails fields in the response it sends us.
      redirectURI: `${window.location.origin}/a/apple`, // As registered along with our service ID
      state: nonce.state, // Any string of your choice that you may use for some logic. It's optional and you may omit it.
      usePopup: true, // Important if we want to capture the data apple sends on the client side.
      nonce: nonce.nonce,
    });
    setAppleInitialized(true);
  };

  const initializeFacebookLogin = () => {
    setTimeout(() => {
      window?.fbAsyncInit?.();
    }, 4000);
  };

  useEffect(() => {
    // @ts-ignore
    insertGoogleScript();
    initializeAppleLogin();
    initializeFacebookLogin();
  }, [insertGoogleScript, nonce]);

  return {
    appleInitialized,
  };
}
